<script lang="ts">
  import { t } from '$core/i18n';
  import { createGroup } from '$features/social';
  import { Modal } from '$ui/primitives/Modal';
  import { Button } from '$ui/primitives/Button';
  import { Input } from '$ui/primitives/Input';

  let {
    onClose,
    onCreated
  }: {
    onClose: () => void;
    onCreated: () => void;
  } = $props();

  let name = $state('');
  let busy = $state(false);
  let message = $state<string | null>(null);

  async function submit(): Promise<void> {
    const trimmed = name.trim();
    if (trimmed.length < 1 || trimmed.length > 40 || busy) return;
    busy = true;
    message = null;
    try {
      const res = await createGroup(trimmed);
      if (res.ok) {
        onCreated();
        onClose();
      } else if (res.error === 'invalid_name') {
        message = t('groups.invalidName');
      } else {
        message = t('groups.createError');
      }
    } finally {
      busy = false;
    }
  }

  let open = $state(true);
</script>

<Modal
  bind:open
  title={t('groups.createTitle')}
  size="sm"
  onclose={onClose}
>
  <div class="body">
    <Input
      type="text"
      maxlength={40}
      label={t('groups.name')}
      placeholder={t('groups.namePlaceholder')}
      bind:value={name}
      error={message ?? undefined}
      onkeydown={(e) => e.key === 'Enter' && void submit()}
    />
  </div>

  {#snippet footer()}
    <Button variant="outline" disabled={busy} onclick={onClose}>
      {t('groups.cancel')}
    </Button>
    <Button
      variant="filled"
      loading={busy}
      disabled={busy || name.trim().length < 1}
      onclick={() => void submit()}
    >
      {busy ? t('groups.creating') : t('groups.create')}
    </Button>
  {/snippet}
</Modal>

<style>
  .body {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
  }
</style>